<template>
  <div>
    <b-row
      align-content="center"
      class="d-flex justify-content-center"
      v-if="getIsCompName && mobileSize"
    >
      <b-col
        cols="4"
        align-self="center"
        class="d-flex justify-content-center py-2"
      >
        <b-img :src="handleTitleImgSource" fluid class="img-height" />
      </b-col>
      <b-col cols="8" align-self="center" class="d-flex justify-content-start">
        <b-row align-content="center">
          <b-col
            cols="12"
            align-self="center"
            class="d-flex justify-content-start"
          >
            <span class="black-text font-weight-bold font-size-medium">
              {{ textHandler.title }}
            </span>
          </b-col>
          <b-col
            cols="12"
            align-self="center"
            class="d-flex justify-content-start"
          >
            <span class="light-grey-text font-size-medium-small">
              {{ textHandler.subtitle }}
            </span>
          </b-col>
        </b-row>
      </b-col>
      <ShetabStepperNewVersion />
    </b-row>
    <b-row
      align-content="center"
      class="d-flex justify-content-center"
      v-if="!mobileSize"
    >
      <b-col cols="12" class="d-flex justify-content-center">
        <b-img
          :src="handleTitleImgSource"
          fluid
          class="img-height"
          :class="{ 'shetab-img-height': getIsCompName === 'shetab' }"
        />
      </b-col>
      <b-col cols="12" class="d-flex justify-content-center">
        <span class="black-text font-weight-bold font-size-medium text-center">
          {{ textHandler.title }}
        </span>
      </b-col>
      <b-col cols="12" class="d-flex justify-content-center">
        <span class="light-grey-text font-size-medium-small text-center">
          {{ textHandler.subtitle }}
        </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ShetabStepperNewVersion from "@/components/ShetabStepperNewVersion";
import { mapGetters } from "vuex";
export default {
  name: "HeaderNewVersion",
  components: { ShetabStepperNewVersion },
  computed: {
    ...mapGetters(["getStepperPage", "getPaymentSuccess", "getIsCompName"]),
    mobileSize() {
      return window.innerWidth < 990;
    },
    handleTitleImgSource() {
      switch (this.getIsCompName) {
        case "shetab":
          return require("@/assets/images/shetab-first-page.png");
        case "perfectMoney":
          return require("@/assets/images/perfect-money-new-version.png");
        case "cardToCard":
        case "accountToAccount":
        case "indirectGroup":
          return require("@/assets/images/c2c-new-version.png");
        case "cryptoGroup":
        case "tron":
        case "tether":
          return require("@/assets/images/tether-new-version.png");
        case "shaparak":
          return require("@/assets/images/shaparak-new-version.png");
        default:
          return require("@/assets/images/shetab-first-page.png");
      }
    },
    shetabTextHandler() {
      let textObj = { title: "", subtitle: "" };
      switch (this.getStepperPage) {
        case "pageOne":
          textObj.title = this.$translate("forRegister");
          textObj.subtitle = this.$translate("onlyEnterCardNumberAndMobile");
          return textObj;
        case "pageTwo":
          textObj.title = this.$translate("phoneNumberAccept");
          textObj.subtitle = this.$translate(
            "enterTheSentCodeToYourMobilePhone"
          );
          return textObj;
        case "pageThree":
          textObj.title = this.$translate("payment");
          textObj.subtitle = this.$translate("pleaseEnterCardInfo");
          return textObj;
        case "pageFour":
          textObj.title = this.$translate("transactionResult");
          textObj.subtitle = `${
            this.getPaymentSuccess
              ? this.$translate("paymentSuccessful")
              : this.$translate("paymentFailed")
          }`;
          return textObj;
        default:
          return "";
      }
    },
    perfectMoneyTextHandler() {
      let textObj = { title: "", subtitle: "" };
      switch (this.getStepperPage) {
        case "pageOne":
          textObj.title = this.$translate("perfectMoney");
          textObj.subtitle = this.$translate(
            "onlyEnterVoucherNumberAndActivationCode"
          );
          return textObj;
        default:
          return "";
      }
    },
    vouchersTextHandler() {
      let textObj = { title: "", subtitle: "" };
      switch (this.getStepperPage) {
        case "pageOne":
          textObj.title = this.$translate("vouchers");
          textObj.subtitle = this.$translate("onlyEnterVouchersNumber");
          return textObj;
        default:
          return "";
      }
    },
    cardToCardTextHandler() {
      let textObj = { title: "", subtitle: "" };
      switch (this.getStepperPage) {
        case "pageOne":
          textObj.title = this.$translate("cardToCardGateway");
          textObj.subtitle = this.$translate(
            "onlyAfterThePaymentEnterYourCardNumber"
          );
          return textObj;
        case "pageTwo":
          textObj.title = this.$translate("cardToCardGateway");
          textObj.subtitle = this.$translate("enterPayingAmountAndCardNumber");
          return textObj;
        case "pageThree":
          textObj.title = this.$translate("cardToCardGateway");
          textObj.subtitle = this.$translate("enterPayingAmountAndCardNumber");
          return textObj;
        default:
          return "";
      }
    },
    accountToAccountTextHandler() {
      let textObj = { title: "", subtitle: "" };
      switch (this.getStepperPage) {
        case "pageOne":
          textObj.title = this.$translate("accountToAccountGateway");
          textObj.subtitle = this.$translate(
            "onlyAfterThePaymentEnterYourAccountNumber"
          );
          return textObj;
        case "pageTwo":
          textObj.title = this.$translate("accountToAccountGateway");
          textObj.subtitle = this.$translate("accountToAccountBankSelect");
          return textObj;
        case "pageThree":
          textObj.title = this.$translate("accountToAccountGateway");
          textObj.subtitle = this.$translate(
            "enterPayingAmountAndAccountNumber"
          );
          return textObj;
        default:
          return "";
      }
    },
    indirectGroupTextHandler() {
      let textObj = { title: "", subtitle: "" };
      switch (this.getStepperPage) {
        case "pageOne":
          textObj.title = this.$translate("indirect");
          textObj.subtitle = this.$translate(
            "onlyAfterThePaymentEnterYourAccountNumber"
          );
          return textObj;
        case "pageTwo":
          textObj.title = this.$translate("accountToAccountGateway");
          textObj.subtitle = this.$translate("accountToAccountBankSelect");
          return textObj;
        case "pageThree":
          textObj.title = this.$translate("accountToAccountGateway");
          textObj.subtitle = this.$translate(
            "enterPayingAmountAndAccountNumber"
          );
          return textObj;
        default:
          return "";
      }
    },
    tetherTronTextHandler() {
      let textObj = { title: "", subtitle: "" };
      switch (this.getStepperPage) {
        case "pageOne":
          textObj.title =
            this.getIsCompName === "tether" ||
            this.getIsCompName === "tron" ||
            this.getIsCompName === "cryptoGroup"
              ? this.$translate("tetherGateway")
              : this.$translate("tronGateway");
          textObj.subtitle = this.$translate("onlyReceiveYourWalletAndDeposit");
          return textObj;
        case "pageTwo":
          textObj.title = this.$translate("tetherGateway");
          textObj.subtitle = this.$translate("depositAmountToTheWalletBelow");
          return textObj;
        default:
          return "";
      }
    },
    shaparakTextHandler() {
      let textObj = { title: "", subtitle: "" };
      switch (this.getStepperPage) {
        case "pageOne":
          textObj.title = this.$translate("shaparakGateway");
          textObj.subtitle = this.$translate("onlyEnterCardNumberAndMobile");
          return textObj;
        case "pageTwo":
          textObj.title = this.$translate("shaparakGateway");
          textObj.subtitle = this.$translate("enterCardInfoAndPassword");
          return textObj;
        case "pageThree":
          textObj.title = this.$translate("shaparakGateway");
          textObj.subtitle = this.$translate("transactionResult");
          return textObj;
        default:
          return "";
      }
    },
    textHandler() {
      switch (this.getIsCompName) {
        case "shetab":
          return this.shetabTextHandler;
        case "perfectMoney":
          return this.perfectMoneyTextHandler;
        case "cardToCard":
          return this.cardToCardTextHandler;
        case "accountToAccount":
          return this.accountToAccountTextHandler;
        case "indirectGroup":
          return this.indirectGroupTextHandler;
        case "cryptoGroup":
        case "tron":
        case "tether":
          return this.tetherTronTextHandler;
        case "shaparak":
          return this.shaparakTextHandler;
        case "vouchers":
          return this.vouchersTextHandler;
        default:
          // Handle the default case if necessary
          return "";
      }
    },
  },
};
</script>

<style scoped>
.img-height {
  max-height: 13vh !important;
  min-height: 13vh !important;
}
</style>
